import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';

import { makeStyles } from '@material-ui/core/styles';

import {
  osBlockCampaignList,
  osBlockAdverList,
  osBlockSet,
} from 'lib/api/adver';
import { showSuccessSnackbar } from 'modules/snackbar';
import { addAllList } from 'modules/common';

import NewInput from 'components/atoms/NewInput';
import NewButton from 'components/molecules/NewButton';
import MbRadioGroup from 'components/molecules/MbRadioGroup';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import Modal from 'components/organisms/NewModal';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

const useStyles = makeStyles((theme) => ({
  active: {
    backgroundColor: '#79bd2f',
    '& svg': {
      color: '#fff',
    },
  },
  blockBtn: {
    '&:hover': {
      backgroundColor: '#79bd2f',
      '& svg': {
        color: '#fff',
      },
    },
  },
}));

const Advertiser = (props) => {
  const classes = useStyles();
  const { pageType } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isAdverPage = pageType === 'adver';
  let initParams = {
    sort: 'desc',
    order: 'LAST_DATE',
    osTpCode: 'all',
    blockFlag: '01',
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [tempParams, setTempParams] = useState(initParams);

  const initModal = {
    open: false,
    params: {},
  };
  const [modal, setModal] = useState(initModal);
  const [reFetch, setReFetch] = useState(false);

  const osTpCodeList = [
    { label: 'AOS', value: '01' },
    { label: 'IOS', value: '02' },
  ];
  const blockFlagList = [
    { label: '전체', value: 'all' },
    { label: '보기', value: '01' },
  ];
  const stateList = [
    { label: '차단', value: '01' },
    { label: '해제', value: '02' },
  ];

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
    if (reFetch === true) {
      setReFetch(false);
    }
  }, [initialization, reFetch]);

  const customized = {
    AOS_BLOCK_FLAG: {
      makeBody: (rowObj, headsMap) => {
        return !!rowObj['AOS_BLOCK_FLAG'] ? (
          <NewButton
            name="delete"
            title={rowObj['AOS_BLOCK_FLAG'] === '01' ? t('해제') : t('노출')}
            iconBtn
            icon="faPowerOff"
            disableRipple
            onClick={() => {
              let newParams = {};
              isAdverPage
                ? (newParams = {
                    adverIds: rowObj['ADVER_ID'],
                    aos_state: rowObj['AOS_BLOCK_FLAG'] === '01' ? '02' : '01',
                  })
                : (newParams = {
                    siteCodes: rowObj['SITE_CODE'],
                    aos_state: rowObj['AOS_BLOCK_FLAG'] === '01' ? '02' : '01',
                  });
              handleSetBlock(newParams);
            }}
            className={clsx(
              rowObj['AOS_BLOCK_FLAG'] === '01' && classes.active,
              classes.blockBtn
            )}
          />
        ) : (
          '-'
        );
      },
      bodyStyle: { width: 80 },
    },
    IOS_BLOCK_FLAG: {
      makeBody: (rowObj, headsMap) => {
        return !!rowObj['IOS_BLOCK_FLAG'] ? (
          <NewButton
            name="delete"
            title={rowObj['IOS_BLOCK_FLAG'] === '01' ? t('해제') : t('노출')}
            iconBtn
            icon="faPowerOff"
            disableRipple
            onClick={() => {
              let newParams = {};
              isAdverPage
                ? (newParams = {
                    adverIds: rowObj['ADVER_ID'],
                    ios_state: rowObj['IOS_BLOCK_FLAG'] === '01' ? '02' : '01',
                  })
                : (newParams = {
                    siteCodes: rowObj['SITE_CODE'],
                    ios_state: rowObj['IOS_BLOCK_FLAG'] === '01' ? '02' : '01',
                  });
              handleSetBlock(newParams);
            }}
            className={clsx(
              rowObj['IOS_BLOCK_FLAG'] === '01' && classes.active,
              classes.blockBtn
            )}
          />
        ) : (
          '-'
        );
      },
      bodyStyle: { width: 80 },
    },
    LAST_DATE: {
      makeBody: (rowObj, headsMap) => {
        return !!rowObj['LAST_DATE'] ? rowObj['LAST_DATE'] : '-';
      },
    },
    ADVRTS_PRDT_CODE: { merged: true },
    ADVRTS_TP_CODE: { merged: true },
  };

  const handleOnReset = () => {
    if (
      JSON.stringify(params) !== JSON.stringify(initParams) ||
      JSON.stringify(tempParams) !== JSON.stringify(initParams)
    ) {
      setInitialization(true);
      setParams(initParams);
      setTempParams(initParams);
    }
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  const handleTempParams = (newParams, name) => {
    let newTempParams = { ...newParams };
    if (!newTempParams[name]) {
      delete newTempParams[name];
    }
    if (JSON.stringify(tempParams) !== JSON.stringify(newTempParams)) {
      setTempParams(newTempParams);
    }
  };

  const handleButtonOnClick = () => {
    if (JSON.stringify(tempParams) !== JSON.stringify(params)) {
      setParams(tempParams);
    }
  };

  const handleSetBlock = (newParams) => {
    osBlockSet(newParams)
      .then((response) => {
        const { message } = response.data;
        handleClickSnackbar({
          message: message,
          option: {
            type: 'success',
          },
        });
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: {
            type: 'error',
          },
        });
      })
      .finally(() => {
        setReFetch(true);
      });
  };

  const handleCheckBtnController = (type, data) => {
    let tempModal = { ...initModal };
    let tmpExlNo = [];
    if (isAdverPage) {
      data.forEach(function (rowData) {
        tmpExlNo.push(rowData['ADVER_ID']);
      });
      tempModal = {
        ...tempModal,
        open: true,
        params: {
          ...tempModal.params,
          adverIds: String(tmpExlNo),
        },
      };
    } else {
      data.forEach(function (rowData) {
        tmpExlNo.push(rowData['SITE_CODE']);
      });
      tempModal = {
        ...tempModal,
        open: true,
        params: {
          ...tempModal.params,
          siteCodes: String(tmpExlNo),
        },
      };
    }
    setModal(tempModal);
  };

  const handleModalClose = () => {
    setModal({
      ...modal,
      open: false,
    });
  };

  const handleSubmit = () => {
    handleSetBlock(modal['params']);
    setModal({
      ...modal,
      open: false,
    });
  };

  const handleModalGetParams = (e) => {
    const { value, name } = e.target;
    setModal({
      ...modal,
      params: {
        ...modal.params,
        [name]: value,
      },
    });
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={handleTempParams}
          params={tempParams}
          useDate={false}
          useExternalFilter={false}
          usePltfomTpCodeFilter={false}
          useDisplayFilter={!isAdverPage}
          useManagerFilter
        />
        <FilterCollection
          label={t('OS')}
          name="osTpCode"
          params={tempParams}
          value={tempParams.osTpCode}
          type="radio"
          list={addAllList(osTpCodeList, 'label', 'value', 'all')}
          callBack={handleTempParams}
          labelKey="label"
          valueKey="value"
        />
        <FilterCollection
          label={t('차단광고주')}
          name="blockFlag"
          params={tempParams}
          value={tempParams.blockFlag}
          type="radio"
          list={blockFlagList}
          callBack={handleTempParams}
          labelKey="label"
          valueKey="value"
        />
        <NewInput
          label={t('광고주ID')}
          type="filter"
          name="adverId"
          params={tempParams}
          value={tempParams['adverId']}
          callBack={handleTempParams}
        />
        {!isAdverPage && (
          <NewInput
            label={t('SC코드')}
            type="filter"
            name="siteCode"
            params={tempParams}
            value={tempParams['siteCode']}
            callBack={handleTempParams}
          />
        )}

        <NewButton onClick={handleButtonOnClick}>{t('검색')}</NewButton>
      </NewFilterWrap>
      <NewTableContainer
        dataReqPromise={isAdverPage ? osBlockAdverList : osBlockCampaignList}
        params={params}
        getParam={getParam}
        customized={customized}
        useFetch={!isAdverPage}
        useCheckBox
        useTotal={false}
        headCallBack={handleCheckBtnController}
        reFetch={reFetch}
        excelTransKey={
          'AOS_BLOCK_FLAG,IOS_BLOCK_FLAG,ADVRTS_PRDT_CODE,ADVRTS_TP_CODE'
        }
        useSearch={false}
        // excelTransKey=""
      />
      <Modal
        open={modal.open}
        headerTitle={t('차단 적용')}
        confirmBtnTitle={t('적용')}
        confirmBtnOpen
        useForm
        handleClose={handleModalClose}
        confirmOnClick={handleSubmit}
      >
        <tr>
          <th style={{ width: 100 }}>IOS</th>
          <td>
            <MbRadioGroup
              radioList={stateList}
              onChange={handleModalGetParams}
              name="ios_state"
            />
          </td>
        </tr>
        <tr>
          <th style={{ width: 100 }}>AOS</th>
          <td>
            <MbRadioGroup
              radioList={stateList}
              onChange={handleModalGetParams}
              name="aos_state"
            />
          </td>
        </tr>
      </Modal>
    </>
  );
};

export default Advertiser;
